export interface PlansState {
  plansList: Array<any>;
  modulesAndFeaturesList: Array<any>;
  planById: any;
  planTemplateById: any;
  addPlansResponse: any;
  updatePlansResponse: any;
  deletePlansResponse: any;
}

export const initialState: PlansState = {
  plansList: null,
  modulesAndFeaturesList: null,
  planById: null,
  planTemplateById: null,
  addPlansResponse: null,
  updatePlansResponse: null,
  deletePlansResponse: null
};
